module.exports = __webpack_public_path__ + "static/media/2.8dd2a4b7.jpg";